export const AI_WORK_EXPERIENCE_MODAL = 'aiWorkExperienceModal'
export const DIALOG_ANALYTICS_LABEL = 'ai_writer_dialog'
export const ANALYTICS_SECTION_NAME = 'work_experience'
